import hubspot from "scripts/hubspot"
import Analytics from "scripts/analytics"
import { ErrorOption } from "react-hook-form"

const useFormSubmit = (handleState, handleMessage, handleError, formId, hubspotFormId, contentfulfields) => {

	const onSubmit = async (data: any) => {
		handleState(true)
		try {
			const { inlineMessage }: any = await hubspot.submitForm(hubspotFormId, data)
			handleMessage({
				type: "success",
				message: inlineMessage,
			})
		} catch (error) {
			if (error.errors) {
				const hubspotErrors = hubspot.getErrors(error, contentfulfields)
				const errorKeys = Object.keys(hubspotErrors)
				errorKeys.forEach(fieldName => {
					handleError(
                        fieldName as never,
                        {
                        	message: hubspotErrors[fieldName],
                        } as ErrorOption
					)
				})

				const { ga } = window as any

				if (errorKeys.length && ga) {
					Analytics.freeEmailBlocked(formId)
				}
			} else {
				handleMessage({
					type: "error",
					message: "Failed to submit the form, please try again later",
				})
			}
		}
		handleState(false)
	}

	return onSubmit
}

export default useFormSubmit